import React, { Component } from "react";
import { connect } from "react-redux";
import {
  dynamicFormModal,
  updateFomeName,
  updateFormList,
  formEdited,
} from "FormBuilderAction";
import LocaleStrings from "Languages";

class QuizFormItems extends Component {
  constructor(props) {
    super(props);
  }

  editForm(item) {
    // console.log("item :- ", item);
    let formNameEdit = item.formname;
    let newObj = JSON.parse(item.formjson);
    let formtype = item.formtype;
    let fixedObj = [];

    this.props.dynamicFormModal({
      key: "edit",
      showModal: true,
      category: formtype,
      fixedFields: fixedObj,
      formDetails: item,
    });
    this.props.updateFomeName(formNameEdit); // Form Name
    this.props.updateFormList(newObj, [], "samearray"); // Updating redux with editing from json
    this.props.formEdited(false); // This is used for edit form
  }

  render() {
    let { listItem } = this.props;

    return (
      <tr>
        <td>
          <div className="vcenter">{listItem.formnumber}</div>
        </td>
        <td>
          <div className="vcenter">{listItem.formname}</div>
        </td>
        <td>
          <div className="vcenter">{listItem.versionno}</div>
        </td>
        <td>
          <div style={{ display: "flex" }}>
            <div style={{ paddingBottom: "5px", textAlign: "center" }}>
              <button
                type="button"
                className="btn btn-custom-table-blue"
                onClick={() => this.editForm(listItem)}
              >
                <i className="fa fa-pencil i-custom-ms"></i>
                {LocaleStrings.button_edit}
              </button>
            </div>
          </div>
        </td>
      </tr>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};
export default connect(mapStateToProps, {
  dynamicFormModal,
  updateFomeName,
  updateFormList,
  formEdited,
})(QuizFormItems);
